import {getValidationError} from '@shared/utils/helpers'

export function notifyErrors(notify, response) {
  if (!notify || !response) return

  notify({type: 'error', text: response.message})

  if (response.errors) {
    notify({type: 'error', text: getValidationError(response.errors)})
  }
}

export function errorNotify(notify, error) {
  if (!notify || !error) {
    return
  }

  const message = error?.response?.data?.message || error?.data?.message || error?.message || null

  if (message) {
    notify({type: 'error', text: message})
  }
}
